import React, { useEffect, useState } from "react";
import "./EbookList.css";
import gd from "../../images/green-dark-tick.svg";
import bc from "../../images/book-cover.svg";
import dd from "../../images/download-white.svg";
import lb from "../../images/lock-black.svg"
import pl from "../../images/play-btn.svg"
import pt from "../../images/purple-tick.svg"
import ff from "../../images/pp-logo.gif";
import Dashboard from "../Dashboard/Dashboard";
import { END_URL, IMG_URL, SITE_URL } from "../../config";
import axios from "axios";
import buttonloader from "../../images/buttonloader.gif";


function EbookList({globaltest,token}) {

    const [loading, setLoading] = useState(true);

    const [pageLoading, setPageLoading] = useState(false);

    const [fadeIn, setFadeIn] = useState(false);

    const [ebooks, setEbooks] = useState([]);

    const [ebookDetail, setebookDetail] = useState([]);

    const [loadingPay, setloadingPay] = useState(null);

    const [error, setError] = useState("");

    const [currentPage, setCurrentPage] = useState(1);
    const [pagination, setPagination] = useState(null);

    const [loadingPageNumber, setLoadingPageNumber] = useState(null);

    const handlePageChange = (page) => {

        if (page === currentPage || pageLoading) return;

        setLoadingPageNumber(page);
        setCurrentPage(page);
    };

    useEffect(() => {

        fetchEbooks(1, true);

    }, []);

    useEffect(() => {

        if (loading) return;

        fetchEbooks(currentPage, false);

    }, [currentPage]);

    const fetchEbooks = async (page = 1, initial = false) => {

      try {

          if (initial) {
              setLoading(true);
          } else {
              setPageLoading(true);
          }

          const response = await axios.get(
              `${END_URL}/ebook-list?page=${page}`,
              {
                  headers: {
                      Authorization: `Bearer ${token}`,
                      "Content-Type": "application/json",
                  },
              }
          );

          if (response.data.success) {

              setEbooks(response.data.data || []);
              setebookDetail(response.data.ebook_detail || []);
              setPagination(response.data.pagination);

              setFadeIn(false);

              setTimeout(() => {
                  setFadeIn(true);
              }, 50);
          }

      } catch (error) {

          console.log(error);

      } finally {

          setLoading(false);
          setPageLoading(false);
          setLoadingPageNumber(null);
      }
  };

     const HandlePament = async (ebook) => {
      
          try {
    
            setloadingPay(ebook);
    
            const response = await fetch(`${END_URL}/ebook-store-payment`, {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                ebook_id :ebook
              }),
            });
    
            const data = await response.json();
    
            if (data.payment) {
    
              window.location.href = data.payment;
            } else {
    
              setloadingPay(null);
    
            }
    
          } catch (error) {
    
            console.error("Error sending result:", error);
            setloadingPay(null); 
          }
      };

    const handleRedirect = (link) => {

        if (!link) return;

        window.location.href = link;

    };

   const handleDownload = (ebookFile) => {
    
      if (!ebookFile) {
          return;
      }

      const link = document.createElement('a');
      link.href = `${IMG_URL}/d0/${ebookFile}/download`;
      link.download = '';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  };

    if (loading) {

        return (
            <div className="loadingDiv">
                <img src={ff} alt="Loading..." />
            </div>
        );
    }

  return (
    <div className="ebooklist-cont">
      <div className="container">

        <div className="row">

            <div className="col-md-3">

              <Dashboard globaltest={globaltest} />

            </div>

            <div className="col-12 col-sm-12 col-md-9 col-lg-9">
            
              <div className="row">

                <div className="ebooklist-title" dangerouslySetInnerHTML={{__html:ebookDetail?.user_ebook_title}} />
            
              </div>

              <div className={`row ebook-list-wrapper ${fadeIn ? "fade-in" : ""}`} >

                {ebooks?.map((ebook, index) => {

                    const isOwned = ebook?.is_paid == 1;

                    const SubInclude = ebook?.is_subscription == 1;

                    return (

                            <div className="col-md-4">

                              <div className="ebooklist-box">

                                  <div className="ebooklist-iconDiv"
                                        style={{
                                            "--text-color-h6": isOwned
                                                ? "#39B46E"
                                                : SubInclude
                                                ? "#88619A"
                                                : "#000",

                                            "--border-box-color": isOwned
                                                ? "#39B46E"
                                                : SubInclude
                                                ? "#88619A"
                                                : "#E0E0E0",

                                            "--box-bg-color": isOwned
                                                ? "#F0F6F4"
                                                : SubInclude
                                                ? "#E4DCEE"
                                                : "#FBFBFB"
                                        }}
                                    >
                                    
                                    <img src={isOwned? gd : SubInclude ?pl :lb}  alt="" />

                                    <h6>{ebook?.owner_title}</h6>

                                </div>

                                <div className="ebooklist-imgDiv">
                                  <img src={`${IMG_URL}/d0/${ebook?.book_cover}`} alt="" />
                                </div>

                                <div className="ebooklist-contentall">

                                  <h6>{ebook?.title}</h6>

                                  <div dangerouslySetInnerHTML={{__html:ebook?.short_description}}/>

                                  <h5>${ebook?.price}</h5>

                                  <div className="adapter-single-acout-dec">

                                    <img alt="" src={gd} />

                                      <div dangerouslySetInnerHTML={{__html:ebookDetail?.ebook_pay_content}}/>
                                      
                                  </div>

                                  <div className="ebooklist-allbtn">

                                    {isOwned || SubInclude  ? (

                                      <button className="ebook-download"  onClick={() => handleDownload(ebook?.ebook_file)} >
                                       
                                        <img src={dd} alt="" /> <span>Download</span>

                                      </button>

                                    ):(

                                      <button onClick={() => !loadingPay && HandlePament(ebook?.id)} style={{ pointerEvents: loadingPay ? "none" : "auto" }} className="ebook-buy-now">Buy Now {loadingPay === ebook?.id && (<img width={50} src={buttonloader} alt="Loading" /> )} </button>
                                    )}

                                    <button className="ebook-download" onClick={() => handleRedirect(ebookDetail?.ebook_take_quiz_link)} >{ebookDetail?.ebook_take_quiz_label}</button>

                                  </div>
                                </div>
                              </div>
                            </div>

                    )}
                  )
                }

                {pagination?.last_page > 1 && (

                   <div className="ebook-pagination">

                      <button
                          disabled={currentPage <= 1 || pageLoading}
                          onClick={() => handlePageChange(currentPage - 1)}
                      >
                          {pageLoading && loadingPageNumber === currentPage - 1
                              ? "Loading..."
                              : "Previous"}
                      </button>

                      {[...Array(pagination.last_page)].map((_, index) => {

                          const pageNumber = index + 1;

                          return (
                              <button
                                  key={pageNumber}
                                  disabled={pageLoading}
                                  className={pageNumber === currentPage ? "active" : ""}
                                  onClick={() => handlePageChange(pageNumber)}
                              >
                                  {pageLoading && loadingPageNumber === pageNumber ? (
                                      <>
                                          <span className="spinner-border spinner-border-sm me-1"></span>
                                          {pageNumber}
                                      </>
                                  ) : (
                                      pageNumber
                                  )}
                              </button>
                          );
                      })}

                      <button
                          disabled={
                              currentPage >= pagination.last_page ||
                              pageLoading
                          }
                          onClick={() => handlePageChange(currentPage + 1)}
                      >
                          {pageLoading && loadingPageNumber === currentPage + 1
                              ? "Loading..."
                              : "Next"}
                      </button>

                  </div>

                )}

              </div>

            </div>

          </div>
      </div>
    </div>
  );
}

export default EbookList;
